import React, { Component } from 'react';
import Slider from "react-slick";
import { BASE } from '../api/api';
import cachios from 'cachios'
import './video.css'
import ReactPlayer from 'react-player'



class VideoComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            video_arr: ['https://www.youtube.com/watch?v=iAEmdmYLkzk', "https://www.youtube.com/watch?v=iAEmdmYLkzk", "https://www.youtube.com/watch?v=iAEmdmYLkzk"],
            videoarr: undefined,
            vidlink: undefined,
            modalOpen: false,
            videoId: '',
            pg: 0,
            nav1: null,
            nav2: null
        };
    }

    componentDidMount() {
        cachios.get(BASE + 'jsonapi/node/medias?include=field_thumbnail&sort=-created', {
            ttl: 500 /* seconds */,
            })
            .then((data) => {
                let whole_data = data.data.data
                let incl_data = data.data.included
                let dat = [];
                let img_dat = [];
                for (let i = 0; i < whole_data.length; i++) {
                    for (let j = 0; j < incl_data.length; j++) {
                        if (incl_data[j].type === "file--image") {
                            if (whole_data[i].relationships.field_thumbnail.data.id == incl_data[j].id) {
                                let tmp = whole_data[i].attributes
                                tmp.img_url = incl_data[j].attributes.uri.url
                                dat.push(tmp)
                            }
                        }

                    }

                }
                for (let i = 0; i < dat.length; i++) {
                    let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                    let match = undefined;
                    match = dat[i].field_video.match(regExp);

                    if (match && match[2].length == 11) {
                        img_dat.push(match[2])
                    } else {
                        return 'error';
                    }
                }
                this.setState({
                    whole_videoarr: dat,
                    vidlink: img_dat,
                    nav1: this.slider1,
                    nav2: this.slider2

                })
            })
            .catch((err) => {
            })

    }
    next() {
        this.slider2.slickNext();
    }
    previous_node() {

        this.slider2.slickPrev();
    }
    render() {
        let img_arr = this.state.whole_videoarr
        // let settings = {
        //     dots: true,
        //     dotsClass: "slick-dots slick-thumb",
        //     infinite: false,
        //     speed: 500,
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     arrows: false,
        // };
        // if (this.state.whole_videoarr) {
        //     for (let i = 0; i < 4; i++) {

        //         let dt = this.state.pg > 0 ? i + (this.state.pg * 4) : 0 + i
        //         if (this.state.whole_videoarr[dt]) {
        //             img_arr.push(this.state.whole_videoarr[dt])
        //         }

        //     }

        //     if (img_arr.length > 0) {
        //         if (img_arr.length == 1) {
        //             videoarr = img_arr;
        //         }
        //         else
        //             videoarr = undefined
        //         videoarr = img_arr
        //     }
        //     else {
        //         videoarr = undefined
        //     }
        // }


        return (

            <div>
                <Slider
                    asNavFor={this.state.nav2}
                    ref={slider => (this.slider1 = slider)}
                    arrows={false}
                >
                    {this.state.whole_videoarr ? this.state.whole_videoarr.map((img, id) => {
                        // let sr = 'https://www.youtube.com/embed/' + img
                        let ur = BASE + img.img_url
                        return (
                            <div>
                                {/* <img width="420" height="300" src={ur} frameBorder="1"/> */}
                                <div className="videoContainer" style={{ backgroundImage: "url(" + ur + ")" }}
                                onClick={() => (this.setState({ modalOpen: true, videoId: img.field_video }), this.props.checkopen(true))}
                                >
                                    <div className="overlay_video">
                                        <div className="vi_icon"></div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                        : ''}
                </Slider>
                <div className="img_thumb">
                    <div onClick={() => this.previous_node()} className="arr arrow_prev" ></div>
                    <div onClick={() => this.next()} className="arr arrow_next"></div>
                    <Slider
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        slidesToShow={4}
                        swipeToSlide={true}
                        focusOnSelect={true}
                        arrows={false}
                    >
                        {img_arr ? img_arr.map((img, id) => {
                            // let sr = 'https://www.youtube.com/embed/' + img
                            let ur = BASE + img.img_url
                            return (
                                <div>
                                    {/* <img width="420" height="300" src={ur} frameBorder="1"/> */}
                                    <div className="videoContainer con"
                                        style={{ backgroundImage: "url(" + ur + ")" }}
                                    // onClick={() => (this.setState({ modalOpen: true, videoId: img.field_video }), this.props.checkopen(true))}
                                    >
                                    </div>
                                </div>
                            )
                        })
                            : ''}
                    </Slider>

                </div>
                <div style={{ display: this.state.modalOpen === true ? '' : 'none' }} className="videoModal">
                    <div onClick={() => (this.setState({ modalOpen: false, videoId: '' }), this.props.checkopen(false))} className="video_close"></div>
                    <div className="video_play">



                        <ReactPlayer url={this.state.modalOpen == true ? this.state.videoId : ''} playing={this.state.modalOpen == true ? true : false} controls={true} />

                    </div>
                </div>
            </div>

        );
    }
}

export default VideoComponent;